<template>
  <div>

    <v-toolbar flat fixed>
      <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      <v-toolbar-title class="white--text">Print Templates</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="fn_new"><v-icon>add</v-icon></v-btn>
      <!-- <v-btn icon @click="fn_getBottomMenu(901)"><v-icon>more_vert</v-icon></v-btn> -->

      <v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" slot="extension" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
    </v-toolbar>

    <div class="display_msg" v-if="!filteredItems.length">No Items</div>

    <div grey-back class="hasToolbar hasExtension">
      <v-list nopadding>
        <div v-for="(item, index) in filteredItems" :key="index">
          <v-list-tile @click="fn_edit(item.printTemplateId)">
            <v-list-tile-content>
              <v-list-tile-title>{{item.name}}</v-list-tile-title>
            </v-list-tile-content>  
           <!--  <v-list-tile-action>
                <v-btn icon flat @click="fn_getBottomMenu(902, item.printTemplateId)"><v-icon>more_vert</v-icon></v-btn>
            </v-list-tile-action> -->
          </v-list-tile>
          <v-divider v-if="filteredItems.length-1 != index"></v-divider>
        </div>
      </v-list> 
    </div>
  </div>
</template>

<script>
var tagId = null;
const menuItem = require('../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../config.js').configs.bottomSheetMenu;

  export default{
    data(){
      return{
        listItems:[],
        searchValue:'',
        scrollPositionTop:0,
        selectedItemId:null
      }
    },
    methods:{
      fn_new: function () {
        this.$router.push({path:"/printtemplate/items/new", query:{tagId:this.guid()}});
      },

      fn_goBack: function(){
        this.$router.go(-1);
      },

      fn_menuItemClick: function(tagId, menuId, menuAction){
        // tagId id form future use
        // menuId id form future use
        if(menuAction=='new'){
          this.fn_new();
        }
        else if(menuAction=='edit'){
          this.fn_edit(this.selectedItemId);
        }
        else if(menuAction=='copy'){
          this.$router.push({path:"/printtemplate/items/new", query:{tagId:this.guidWeb(), itemId:this.selectedItemId, copy:true}});
        }
      },

      fn_edit: function (itemId) {
        // tagId id form future use
        // itemName id form future use
        this.$router.push("/printtemplate/items/"+itemId+"/edit");
      },

      // fn_getBottomMenu: function (elementId, itemId) {

      //   itemId ? this.selectedItemId = itemId : '';

      //   let bottomMenu;

      //   if(elementId == bottomSheetMenu.toolBar.Id){
      //     bottomMenu = {"BottomMenu": [menuItem.help]};
      //   }
      //   else if(elementId == bottomSheetMenu.masterListItems.Id){
      //     bottomMenu = {"BottomMenu": [menuItem.edit, menuItem.copy]};
      //   }

      //   this.setBottomMenu(tagId, bottomMenu, 
      //     {
      //       onSuccess: function (response) {
      //         console.log(response);
      //       },
      //       onError: function (error) {
      //         console.log(error);
      //       }
      //     }
      //   )
      // },

      fn_getItems: function () {
        let filterObject = {};

        let self = this;
        this.getItems("PrintTemplateList", filterObject, 
          {
            onSuccess: function (response) {
              console.log(response);
              self.listItems = JSON.parse(response);
            },
            onError: function (error) {
              console.log(error);
            }
          }
        )
      },

      fn_showWebView: function () {
        var viewObject = {};
        var self = this;
        this.showWebView(tagId, viewObject, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
            // onChange: null,
            onMenuItemClick: function (tagId, menuId, menuAction) {
              self.fn_menuItemClick(tagId, menuId, menuAction)
            } 
          }
        );
      },
    },
    mounted: function () {
      tagId = this.$route.query.tagId;

      this.fn_showWebView();
      this.fn_getItems();
      window.js_globals.fn_onBackPress = this.fn_goBack;

      let self = this;
      document.addEventListener('scroll', function () {
        self.scrollPositionTop = window.pageYOffset
      })
    },
    computed:{
      filteredItems: function () {
        let searchText = this.searchValue.toLowerCase();

        return this.listItems.filter(item => {
          let fieldItem = item.name.toLowerCase();
          return fieldItem.match(searchText);
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/print_templates/items.vue